export const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN;
export const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID;
export const AUTH0_AUDIENCE = import.meta.env.VITE_AUTH0_AUDIENCE;

export const API_URL = import.meta.env.VITE_API_URL;

export const USER_ROLES = {
  owner: 'OWNER',
  loanOfficer: 'LOAN_OFFICER',
  administrative: 'ADMINISTRATIVE',
};
